import { render } from "./LoadingProcess.vue?vue&type=template&id=d5ff28ce"
import script from "./LoadingProcess.vue?vue&type=script&lang=ts"
export * from "./LoadingProcess.vue?vue&type=script&lang=ts"
script.render = render

export default script